module.exports = __webpack_public_path__ + "img/24_BF2_face_the_food_shortages.1206444c.jpg";